import { useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { useModals } from "@/modals"
import { useAppDispatch, useAppSelector } from "@/store"
import {
  COMMON_BID_VARIANT_ID,
  useGetMyMatchSessionQuery,
  useMatchSearchMutation
} from "@/store/apis/matchAPI"
import { useGetPlayerProfileQuery } from "@/store/apis/playerAPI"
import { setFindMatchMode } from "@/store/slices/findMatch"
import { MatchSelectors } from "@/store/slices/match"

export const useMatchSearch = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { openModal, closeAllModals } = useModals()

  const matchSessionRedux = useAppSelector(MatchSelectors.selectMatchSession())

  const { data: playerProfile } = useGetPlayerProfileQuery()
  const { data: matchSessionQuery } = useGetMyMatchSessionQuery(
    {
      playerId: playerProfile?._id ?? ""
    },
    {
      skip: !playerProfile?._id
    }
  )

  const [searchMatch, { isLoading }] = useMatchSearchMutation()

  const matchSession = useMemo(() => {
    return matchSessionQuery ?? matchSessionRedux
  }, [matchSessionQuery, matchSessionRedux])

  const isMatchFound = ["PENDING", "ACTIVE"].includes(
    matchSession?.status || ""
  )

  const toDeck = (sessionId?: string, timeout: number = 2000) => {
    setTimeout(() => {
      closeAllModals()
      navigate(`/match/${sessionId ?? matchSession?.sessionId}`)
    }, timeout)
  }

  const handleSearchMatch = async (variant?: string) => {
    try {
      const responseSearch = await searchMatch(
        variant ? { variant } : undefined
      ).unwrap()

      const status = responseSearch.status

      switch (status) {
        case "SEARCHING":
        case "MATCHED":
          dispatch(setFindMatchMode("modal"))

          if (!variant || variant === COMMON_BID_VARIANT_ID) {
            openModal("findMatch")
          } else {
            openModal("findTonMatch")
          }
          break
        case "ALREADY_IN_MATCH":
          toDeck(responseSearch.session?.sessionId, 0)
          break
      }
    } catch (error) {
      console.error(error)
    }
  }

  return { handleSearchMatch, toDeck, isLoading, isMatchFound }
}
